import type {
  FieldSlots as FieldBaseSlots,
  FieldBaseProps,
  FieldBaseState,
  FieldContextValues as FieldContextValuesBase,
} from '@fluentui/react-field';

/**
 * Field component slots
 */
export type FieldSlots = FieldBaseSlots;

/**
 * Field component props
 */
export type FieldProps = FieldBaseProps;

/**
 * Field component state
 */
export type FieldState = FieldBaseState & {
  root: {
    'data-validate-state'?: FieldBaseState['validationState'];
  };
};

/**
 * Field component context values
 */
export type FieldContextValues = FieldContextValuesBase;
